import { __decorate, __metadata } from "tslib";
import { DefaultExposeGroupEnum } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsOptional } from 'class-validator';
import { typify } from '../../common';
import { SettlementConfigurationScopeEnum, SettlementConfigurationStatusEnum } from '../interface';
export class ReadSettlementConfigurationDto {
}
__decorate([
    ApiProperty({ type: typify(String), description: 'Settlement Configuration uniq id value' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], ReadSettlementConfigurationDto.prototype, "id", void 0);
__decorate([
    ApiProperty({
        enum: SettlementConfigurationScopeEnum,
        description: 'Settlement Configuration scope value. Do not use SCOPE_DO_NOT_USE',
        default: SettlementConfigurationScopeEnum.ORGANIZATION,
        example: SettlementConfigurationScopeEnum.ORGANIZATION,
    }),
    IsEnum(SettlementConfigurationScopeEnum, { groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE, DefaultExposeGroupEnum.UPDATE] }),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], ReadSettlementConfigurationDto.prototype, "scope", void 0);
__decorate([
    ApiProperty({
        enum: SettlementConfigurationStatusEnum,
        description: 'The status of the configuration. ACTIVE: the configuration is enabled. INACTIVE: the configuration is disabled.',
        default: SettlementConfigurationStatusEnum.ACTIVE,
        example: SettlementConfigurationStatusEnum.ACTIVE,
    }),
    IsEnum(SettlementConfigurationStatusEnum, { groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE, DefaultExposeGroupEnum.UPDATE] }),
    Expose({ groups: [DefaultExposeGroupEnum.READ, DefaultExposeGroupEnum.CREATE, DefaultExposeGroupEnum.UPDATE] }),
    IsOptional({ groups: [DefaultExposeGroupEnum.CREATE, DefaultExposeGroupEnum.UPDATE] }),
    __metadata("design:type", String)
], ReadSettlementConfigurationDto.prototype, "status", void 0);
__decorate([
    ApiProperty({ type: typify(String), description: 'Settlement Configuration organization id value' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], ReadSettlementConfigurationDto.prototype, "organizationId", void 0);
__decorate([
    ApiProperty({ type: typify(String), description: 'Settlement Configuration destination location id' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], ReadSettlementConfigurationDto.prototype, "destinationLocationId", void 0);
__decorate([
    ApiProperty({ type: typify(String), description: 'Settlement Configuration record created date and time' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], ReadSettlementConfigurationDto.prototype, "createdAt", void 0);
__decorate([
    ApiProperty({ type: typify(String), description: 'Settlement Configuration record updated date and time' }),
    Expose({ groups: [DefaultExposeGroupEnum.READ] }),
    __metadata("design:type", String)
], ReadSettlementConfigurationDto.prototype, "updatedAt", void 0);
//# sourceMappingURL=ReadSettlementConfigurationDto.js.map